export default {
  names: {
    email: 'E-mail',
    password: 'Wachtwoord',
    confirmPassword: 'Bevestig wachtwoord',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    newEmail: 'Nieuw E-mailadres',
    confirmEmail: 'Bevestig Nieuw E-mailadres',
    newPassword: 'Nieuw Wachtwoord'
  }
}
